import React, { useState } from 'react';
import styled from 'styled-components';
import YandexMap from 'src/components/YandexMap';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import HotelNoCoordPopup from 'src/components/YandexMap/components/HotelNoCoordPopup';
import HotelRoulettePopup from 'src/components/YandexMap/components/HotelRoulettePopup';
import HotelLayer from 'src/components/YandexMap/components/HotelLayer';
import type { YandexHotelMapProps } from './types';
import {
  HOTEL_MAP_CONTAINER_TEST_ID,
  HOTEL_NO_COORD_POPUP_TEST_ID,
} from './constants';
import Controls from './components/Controls';

const zoom = 12;

const YMapListener = loadReactComponent('YMapListener', loadModulePromise);

const YandexHotelMap: React.FC<Readonly<YandexHotelMapProps>> = (
  props: YandexHotelMapProps,
) => {
  const {
    isRoulette,
    location,
    onExpand,
    isMobile,
    coordinates,
    setIsMapLoading,
  } = props;

  const [showNoCoordsPopup, setShowNoCoordPopup] = useState(
    isRoulette || !coordinates,
  );

  // Отслеживаем загрузку тайлов
  // @see https://yandex.ru/dev/jsapi30/doc/ru/dg/concepts/events#handler-interface
  const handleStateChanged = () => {
    setIsMapLoading(false);
  };

  const handleCloseNoCoordPopup = () => {
    setShowNoCoordPopup(false);
  };

  return (
    <YandexMapHotelContainer data-testid={HOTEL_MAP_CONTAINER_TEST_ID}>
      {showNoCoordsPopup && (
        <StyledNoCoordsPopupWrapper data-testid={HOTEL_NO_COORD_POPUP_TEST_ID}>
          {isRoulette ? (
            <HotelRoulettePopup
              isMobile={isMobile}
              location={location || ''}
              onClose={handleCloseNoCoordPopup}
            />
          ) : (
            <HotelNoCoordPopup
              isMobile={isMobile}
              location={location}
              onClose={handleCloseNoCoordPopup}
              data-testid={HOTEL_NO_COORD_POPUP_TEST_ID}
            />
          )}
        </StyledNoCoordsPopupWrapper>
      )}

      {coordinates && (
        <YandexMap isMobile={isMobile} zoom={zoom} center={coordinates}>
          <YMapListener onStateChanged={handleStateChanged} />
          <Controls isMobile={isMobile} onExpand={onExpand} />
          <HotelLayer coordinates={coordinates} />
        </YandexMap>
      )}
    </YandexMapHotelContainer>
  );
};

const YandexMapHotelContainer = styled.div`
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
`;

const StyledNoCoordsPopupWrapper = styled.div`
  position: absolute;
  z-index: 11;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default YandexHotelMap;
